import EventBus from "diagram-js/lib/core/EventBus";
import { select, Store } from "@ngrx/store";
import { State } from "@ispm-client/modules/bpmn-modeler/store/state";
import { CloseNotesPanelAction } from "@ispm-client/modules/bpmn-modeler/store/actions/notes-panel.actions";
import { EventType } from "@ispm/shared/bpmn-io/bpmn-js";
import { BpmnModelerConfig } from "@ispm-client/modules/bpmn-modeler/models/bpmn-modeler-config";
import { selectActiveNodeNotesPanel } from "@ispm-client/modules/bpmn-modeler/store/selectors";

export class CloseNotesPanelBehavior {

  private activeNodeNotesPanel: string;

  constructor(protected eventBus: EventBus, private store$: Store<State>, private config: BpmnModelerConfig) {
    const disableNotesPerNode = config && config.behavior && config.behavior.allowNotesPerNode === false;
    if (disableNotesPerNode) {
      return;
    }
    const self = this;
    this.store$.pipe(select(selectActiveNodeNotesPanel)).subscribe((nodeId) => {
      self.activeNodeNotesPanel = nodeId;
    });
    eventBus.on(EventType.SELECTION_CHANGED, function(e) {
      // Avoid closing the notes panel if the selection was changed to the node whose notes are currently open
      if (self.activeNodeNotesPanel) {
        const selection = e.newSelection;
        if (selection.length === 1) {
          const element = selection[0];
          if (element.id === self.activeNodeNotesPanel) {
            return;
          }
        }
      }
      self.store$.dispatch(new CloseNotesPanelAction());
    });
  }
}

CloseNotesPanelBehavior.$inject = ['eventBus', 'store$', 'config'];
